import { removeUndefined } from '../../utils/objects.js';
class BaseField {
    description;
    required;
    log;
    example;
    errorMessage;
    proto;
    references;
    constructor(data = {}) {
        this.errorMessage = data.errorMessage;
        this.description = data.description;
        this.required = data.required;
        this.log = data.log ?? true;
        this.example = data.example;
        this.references = [];
        this.proto = {
            comments: this.description ? [this.description] : [],
            definition: [],
            type: '',
        };
    }
    getExample(_transport) {
        return this.example;
    }
    toSchema(_transport, options) {
        return removeUndefined({
            description: this.description,
            errorMessage: options?.deleteErrorMessage ? undefined : this.errorMessage,
        });
    }
    toJSON(input, _target) {
        return input;
    }
    fromProto(input) {
        return this.fromJSON(input);
    }
}
export default BaseField;
//# sourceMappingURL=BaseField.js.map